// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"27f0be1f","625":"005f659a","977":"9e54955f"}[chunkId] + ".chunk.js";
};